import { SegmentWM, Context } from "./";

// These global variables are set in includes/class-segment.php & includes/class-weedmaps.php
declare var wmPageContext: Context;
declare var wmSegment: SegmentWM;
declare var wmLocationEnabled: boolean;

if (typeof wmPageContext !== "undefined") {
  wmSegment = new SegmentWM(wmPageContext, wmLocationEnabled);
}
